module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/engine-user-agent.js
// module id = 2206
// module chunks = 0